import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchAllMentors } from '../../services/mentorService';
import Layout from '../layout/Layout';
import './Mentors.css';

const MentorsList = () => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    const getMentors = async () => {
      try {
        setLoading(true);
        const mentorsData = await fetchAllMentors();
        setMentors(mentorsData);
        setError('');
      } catch (error) {
        console.error('OGデータの取得に失敗:', error);
        
        // エラーの種類に応じてメッセージを変更
        if (error.code === 'permission-denied') {
          setError('アクセス権限がありません。ログインしてください。');
        } else if (error.code === 'not-found') {
          setError('データが見つかりません。');
        } else {
          setError('データの読み込みに失敗しました。時間をおいて再度お試しください。');
        }
      } finally {
        setLoading(false);
      }
    };
    
    getMentors();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <Layout>
      <div className="about">
        <h2>OG一覧</h2>
        <p>OGをクリックすると、より詳細な情報を見ることができます。</p>
      </div>
      
      <div className="box">
        {loading ? (
          <div className="loading">読み込み中...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : mentors.length === 0 ? (
          <div className="empty-message">OGが登録されていません。</div>
        ) : (
          <ul className="mentors-list">
            {mentors.map((mentor) => (
              <li key={mentor.urlParam} className="mentor-box">
                <Link to={`/mentor/${mentor.urlParam}`} className="mentor-link">
                  <div className="mentor-profile">
                    <img 
                      className="mentor-icon" 
                      src={mentor.アイコンURL || '/app/image/mentor_icon.png'} 
                      alt={mentor.氏名} 
                    />
                    <h1 className="mentor-name">
                      {mentor.氏名}
                    </h1>
                  </div>
                  <div className="mentor-info">
                    <ul>
                      <li className="university">{mentor.出身大学}</li>
                      <li className="graduate">{mentor.卒業した年} 年卒</li>
                      <li className="industry">{mentor.就職先業界}</li>
                      <li className="message">{mentor.一言メッセージ}</li>
                    </ul>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* PC版でのみ表示されるトップに戻るボタン */}
      <button 
        className="scroll-to-top-btn"
        onClick={scrollToTop}
        aria-label="トップに戻る"
      >
        ↑
      </button>
    </Layout>
  );
};

export default MentorsList; 